import type { ReceiptTemplate } from '../schema';

export const academySportsTemplate: ReceiptTemplate = {
  id: 'academy-sports',
  name: 'Academy Sports Receipt',
  brand: 'ACADEMY SPORTS + OUTDOORS',
  description: 'Academy Sports and Outdoors receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'academy-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/academy-sports.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 16,
        addressLines: [
          '+ OUTDOORS',
          'STORE #489',
          '1200 DARK AVENUE',
          'MONSTERVILLE, TX 77001',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'academy-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trans', label: 'Trans:', value: '847291' },
          { id: 'assoc', label: 'Assoc:', value: 'MIKE W.' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'time', label: 'Time:', value: '2:45 PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'academy-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'NIKE RUNNING SHOES', quantity: '1', price: '89.99', sku: '847291034' },
          { id: '2', name: 'UNDER ARMOUR TEE', quantity: '2', price: '24.99', sku: '847291035' },
          { id: '3', name: 'ATHLETIC SOCKS 6PK', quantity: '1', price: '14.99', sku: '847291036' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'academy-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '154.96', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '12.78', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '167.74', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'academy-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'academy-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Returns within 60 days\nwith receipt\n\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

